import React from 'react';
import styled from 'styled-components';

const isBar = (c) =>
  c.fullWidth === true || c.cardType === 'hospitalisation-mediclaim';

const Section = styled.div`
  padding: 20px 20px 24px;
  border-bottom: 8px solid #ededf0;
`;
const Heading = styled.div`
  font-family: var(--font-primary), 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0px;
  color: #0f0b28;
  margin-bottom: 16px;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
`;
const Tile = styled.div`
  background: ${(p) => p.bg || 'var(--maroon, #97144d)'};
  border-radius: 12px;
  aspect-ratio: 1 / 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
`;
const TileLabel = styled.div`
  color: #fff;
  font-family: var(--font-primary), sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  margin-top: 8px;
`;
const Bar = styled.div`
  background: ${(p) => p.bg || 'var(--maroon, #97144d)'};
  border-radius: 12px;
  padding: 12px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
`;
const BarLabel = styled.div`
  color: #fff;
  font-family: var(--font-primary), sans-serif;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
`;
const Icon = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

export default function ImportantLinksGrid({ title, cards = [], onCardClick }) {
  if (!cards.length) return null;
  const tiles = cards.filter((c) => !isBar(c));
  const bars = cards.filter(isBar);
  const click = (card) => onCardClick && onCardClick(card);
  return (
    <Section>
      {title ? <Heading>{title}</Heading> : null}
      {tiles.length > 0 && (
        <Grid>
          {tiles.map((card) => (
            <Tile
              key={card.cardKey}
              data-testid="important-link-tile"
              bg={card.backgroundColorCode}
              onClick={() => click(card)}
            >
              {card.imageUrl ? (
                <Icon src={card.imageUrl} alt={card.title} />
              ) : null}
              <TileLabel>{card.title}</TileLabel>
            </Tile>
          ))}
        </Grid>
      )}
      {bars.map((card) => (
        <Bar
          key={card.cardKey}
          data-testid="important-link-bar"
          bg={card.backgroundColorCode}
          onClick={() => click(card)}
        >
          <BarLabel>{card.title}</BarLabel>
        </Bar>
      ))}
    </Section>
  );
}
